module.exports = __webpack_public_path__ + "img/LoginMaxseatV2.60744a99.png";